import NotificationClient from './NotificationClient';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { NotificationMethods } from '../../constant/MethodNames';

class NestNotificationClient implements NotificationClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public read(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${NotificationMethods.READ}/${id}`);
  }

  public readAll(): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, NotificationMethods.READ_ALL);
  }
}

export default NestNotificationClient;
